import {SocketWebActionController} from '../../SocketActionController.ts'
import {SocketLobbySend} from '../../../../shared/scripts/socket/SocketLobbySend.ts'
import {DiscordInstance} from '../DiscordInstance.ts'
import {CustomLinkUtils} from '../utils/CustomLinkUtils.ts'
import {UIUrlController} from '../../../../shared/scripts/ui_html/UIUrlController.ts'
import {UIPopupFunnelIncentiveController} from '../../ui_popup/UIPopupFunnelIncentiveController.ts'
import {AnalyticEventValue} from '../../../../../shared/entity_datas/EntityDatas.ts'
import {SDKRequest} from '../../../../../shared/DiscordActivityTypes.ts'
import {ColonistMembershipType} from '@colonist/types'
import {ViewPopupBecomeMemberGameplay} from '../../../../shared/scripts/ui_popup/ViewPopupBecomeMemberGameplay.ts'
import {SocketDataTypes} from '../../../../../shared/SocketDataTypes.ts'
import {UIDLandingPageController} from '../../ui_html/landing_page/UIDLandingPageController.ts'

export class SocketDiscordActionController extends SocketWebActionController {
    // eslint-disable-next-line class-methods-use-this
    onStateSessionState() {
        const discordInstance = DiscordInstance.getDiscordInstance()
        const voiceChannelId = discordInstance.voiceChannelId
        const serverProfile = discordInstance.serverProfile
        const roomId = CustomLinkUtils.extractRoomIdFromCustomLink(discordInstance.referralOrReactivationType, discordInstance.isInitialLoad) || UIUrlController.getRoomIdFromUrl()
        SocketLobbySend.joinChannel(voiceChannelId, serverProfile, discordInstance.isInitialLoad, roomId)
        UIPopupFunnelIncentiveController.showPopup(false)
    }

    // eslint-disable-next-line class-methods-use-this
    onStateShowPremiumPopup() {
        const analyticEventValue = AnalyticEventValue.PopupMembershipIncentiveDiscordGeneral
        const checkAction = () => {
            void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.PurchaseMembership, ColonistMembershipType.PremiumMonthly)
        }
        new ViewPopupBecomeMemberGameplay(checkAction, analyticEventValue)
    }

    onChannelRoomUpdate(roomData: SocketDataTypes.ChannelRoomUpdate) {
        if(!(this.uiManager?.landingPage instanceof UIDLandingPageController)) return
        this.uiManager.landingPage.updateDiscordCTAContent(roomData)
        this.uiManager.mainPage.ctaController.updateDiscordCTAContent(roomData)
        DiscordInstance.getDiscordInstance().loadingScreen.hideBackground()
    }
}
